export const NAME = 'user';

export const UserRoles = {
  GUEST: 'guest',
  USER: 'user',
  INSPECTOR: 'inspector',
  DEPARTMENT: 'department',
  SUPERUSER: 'superuser',
};



// WEBPACK FOOTER //
// ./src/modules/user/user.constants.js